import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const Field = ({ label, children }) => <div className="space-y-1.5"><Label>{label}</Label>{children}</div>;

export const DirectoryFields = ({ f, setF, meta }) => {
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e?.target ? e.target.value : e }));
  const subs = (meta?.tree || []).find((c) => c.name === f.category)?.subs || [];
  const txt = (k, label, props = {}) => <Field label={label}><Input value={f[k]} onChange={set(k)} data-testid={`directory-${k}-input`} {...props} /></Field>;
  return (
    <>
      <div className="grid sm:grid-cols-2 gap-4">
        {txt("name", "Nom affiché *", { required: true, placeholder: "Ex. Dr Amina Benali" })}
        {txt("name_ar", "Nom en arabe", { dir: "rtl" })}
        <Field label="Catégorie *">
          <Select value={f.category || undefined} onValueChange={(v) => setF((p) => ({ ...p, category: v, subcategory: "" }))} required>
            <SelectTrigger data-testid="directory-category-select"><SelectValue placeholder="Choisir" /></SelectTrigger>
            <SelectContent>{(meta?.categories || []).map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
        <Field label="Spécialité / sous-catégorie *">
          <Input list="dir-subs" value={f.subcategory} onChange={set("subcategory")} required placeholder={f.category ? "Choisir ou saisir" : "Choisissez d'abord la catégorie"} data-testid="directory-subcategory-input" />
          <datalist id="dir-subs">{subs.map((s) => <option key={s.name} value={s.name} />)}</datalist>
        </Field>
        {txt("first_name", "Prénom")}
        {txt("last_name", "Nom")}
        {txt("phone", "Téléphone", { placeholder: "0550 00 00 00" })}
        {txt("email", "E-mail", { type: "email" })}
        {txt("website", "Site web", { placeholder: "https://" })}
        {txt("address", "Adresse")}
        <Field label="Wilaya">
          <Select value={f.wilaya || undefined} onValueChange={set("wilaya")}>
            <SelectTrigger data-testid="directory-wilaya-select"><SelectValue placeholder="Choisir" /></SelectTrigger>
            <SelectContent>{(meta?.wilayas || []).map((w) => <SelectItem key={w.code} value={w.code}>{w.code} — {w.name}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
        {txt("commune", "Code commune", { placeholder: "Ex. 16030" })}
      </div>
      <Field label="Horaires d'ouverture"><Textarea rows={2} value={f.opening_hours} onChange={set("opening_hours")} placeholder="lundi: 08:00–17:00 · mardi: …" data-testid="directory-hours-input" /></Field>
    </>
  );
};
